import React, { useEffect, useState } from 'react';
import { useTheme } from "@material-ui/core";

export default function WarningBox(props) {
  const theme = useTheme();

  // Calculate the opacity dynamically
  const opacity = '0.8';

  return (
    <div
      style={{
        backgroundColor: `rgba(255, 255, 255, ${opacity})`, // Background color with dynamic opacity towards white
        border: `2px solid ${theme.palette.secondary.main}`, // Thinner border on the bottom
        padding: '16px',
        marginBottom: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        fontFamily: 'Roboto, Arial, sans-serif',
      }}
    >
      <p style={{ margin: '0', fontSize: '14px', color: theme.palette.text.primary }}>
        <strong style={{ color: theme.palette.primary.main }}>Warning:</strong> {props.warning}
      </p>
    </div>
  )
}
